import React from 'react';
import { Helmet } from 'react-helmet-async';
 // ✅ Import Helmet
import LoginSignUp from '../User/LoginSignUp';

const LoginPage = () => {
  return (
    <div className="container py-4">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Login or Sign Up | binzal - Grocery Delivery in Bihar</title>
        <meta name="description" content="Access your binzal account to order groceries, vegetables, and more. Fast delivery across Bihar. Sign up if you're new!" />
        <meta name="keywords" content="binzal login, sign up, grocery app login, Bihar grocery delivery account" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Login to binzal | Grocery Delivery App" />
        <meta property="og:description" content="Login or create your binzal account for fast delivery of groceries and vegetables in Bihar." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <LoginSignUp />
    </div>
  );
};

export default LoginPage;
